module.exports = __webpack_public_path__ + "static/11-88bb1ffeef364f300e5169d72803b9a9.jpeg";